import "./banner/Banner.css";
import Banner from "./banner/Banner";
import About_us from "./about_us/About_us";
import Solution_That_Fit_Needs from "./solution_that_fit_needs/Solution_That_Fit_Needs";
import Driven_By_Purpose from "./driven_by_purpose/Driven_By_Purpose";
import Counter from "./counter/Counter";
import FAQ from "./faq/FAQ";
import Customer_reviews from "./customer_reviews/Customer_reviews";
import Download_free from "./download_free/Download_free";
import Redeem_Your_Coupon from "./redeem_Your_Coupon/Redeem_Your_Coupon";

function Home() {
  return (
    <>
      <Banner />
      <About_us />
      <Solution_That_Fit_Needs />
      <Driven_By_Purpose />
      <Counter />
      <Download_free />
      {/* <Customer_reviews /> */}
      {/* <Redeem_Your_Coupon /> */}
      <FAQ />
    </>
  );
}

export default Home;
